import React from 'react';

import Image from "react-bootstrap/Image";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Spinner from "react-bootstrap/Spinner";

import PopupButton from '../util/PopUp';
import Header from './Header';
import Footer from './Footer';
import '../Estilos/Estilo.scss';




export default class Team extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			currentMembers: [],
			pastMembers: [],
			loading: true,
			miembroName: '',
			miembroDescr: '',
			showModal: false

		};

	}

	render() {
		return (
			<div className="team-page">
				<Header />
				<div className="content-team">
					<Tabs defaultActiveKey="actuales" id="tab-team" className="mb-3" justify>
						<Tab id="tab_actuales" eventKey="actuales" title="Current members">
							<Row xs={1} md={2} className="g-4">
								{this.state.loading ? <Spinner /> : this.state.currentMembers.map(({ name, surname, photo, groupPosition, academicPosition, mail, upm, orcid, scholar, linkedin, github, description }) => {
									return (
										<Card style={{ width: '21rem' }}>

											<img class="Card_img_top" src={process.env.PUBLIC_URL + photo} alt={'Fotogrfía de ' + {name} + {surname}}/>
											<Card.Body className="cuerpo">
												<Card.Title align='center'>{name}<br />{surname}</Card.Title>
												<Card.Subtitle align='center' className="mb-2 text-mute">{groupPosition}<br />{academicPosition}</Card.Subtitle>
												<Card.Link href={"mailto:" + mail} className="">{mail}</Card.Link>
												<div className="simbolos_rrss">
													{upm.length > 0 && upm.startsWith("http") &&
														<a href={upm} target="_blank" rel="noopener noreferrer">
															<img src="assets/img/icons/upm-app.png" />
														</a>
													}
												
													{upm.length > 0 && !upm.startsWith("http") &&
														<a href={'https://portalcientifico.upm.es/es/ipublic/researcher/' + upm} target="_blank" rel="noopener noreferrer">
															<img src="assets/img/icons/upm-app.png" />
														</a>
													}
													
													{orcid.length > 0 &&

														<a href={'http://orcid.org/' + orcid} target="_blank" rel="noopener noreferrer">
															<img src="assets/img/icons/orcid.png" />
														</a>

													}
													{scholar.length > 0 &&

														<a href={'https://scholar.google.com/citations?user=' + scholar + '&hl=en&sortby=pubdate'} target="_blank" rel="noopener noreferrer">
															<img src="assets/img/icons/scholar32.png" />
														</a>

													}
													{linkedin.length > 0 &&

														<a href={'https://www.linkedin.com/in/' + linkedin} target="_blank" rel="noopener noreferrer">
															<img src="assets/img/icons/linkedin.png" />
														</a>

													}
													{github.length > 0 &&

														<a href={'https://github.com/' + github} target="_blank" rel="noopener noreferrer">
															<img src="assets/img/icons/github.png" />
														</a>

													}
												</div>
												<div className='popup-button' mt-auto>
													<PopupButton nombre={name + ' ' + surname} descrip={description} />
												</div>
											</Card.Body>
										</Card>
									);
								})}
							</Row>
						</Tab>
						<Tab eventKey="pasados" title="Past members">
							<Row xs={1} md={2} className="g-4">
								{this.state.loading ? <Spinner /> : this.state.pastMembers.map(({ name, surname, photo, groupPosition, academicPosition, mail, upm, orcid, scholar, linkedin, github, description }) => {
									return (
										<Card style={{ width: '21rem' }}>

											<img class="Card_img_top" src={process.env.PUBLIC_URL + photo}  alt={'Fotogrfía de ' + {name} + {surname}} />
											<Card.Body>
												<Card.Title align='center'><tr>{name}</tr>{surname}</Card.Title>
												<Card.Subtitle align='center' className="mb-2 text-mute">{groupPosition}<br />{academicPosition}</Card.Subtitle>
												<div className="simbolos_rrss">
													{upm.length > 0 &&

														<a href={'https://portalcientifico.upm.es/es/ipublic/researcher/' + upm} target="_blank" rel="noopener noreferrer">
															<Image src="assets/img/icons/upm-app.png" />
														</a>

													}
													{orcid.length > 0 &&

														<a href={'http://orcid.org/' + orcid} target="_blank" rel="noopener noreferrer">
															<Image src="assets/img/icons/orcid.png" />
														</a>

													}
													{scholar.length > 0 &&

														<a href={'https://scholar.google.com/citations?user=' + scholar} target="_blank" rel="noopener noreferrer">
															<Image src="assets/img/icons/scholar32.png" />
														</a>

													}
													{linkedin.length > 0 &&

														<a href={'https://www.linkedin.com/in/' + linkedin} target="_blank" rel="noopener noreferrer">
															<Image src="assets/img/icons/linkedin.png" />
														</a>

													}
													{github.length > 0 &&

														<a href={'https://github.com/' + github} target="_blank" rel="noopener noreferrer">
															<Image src="assets/img/icons/github.png" />
														</a>

													}
												</div>
											</Card.Body>
										</Card>
									);
								})}
							</Row>
						</Tab>
					</Tabs>
				</div>
				<Footer />
			</div>
		)
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		fetch(process.env.PUBLIC_URL + "/assets/json/current-members.json").then(res => res.json()).then(currentMembers => this.setState({ currentMembers, loading: false }));
		fetch(process.env.PUBLIC_URL + "/assets/json/past-members.json").then(res => res.json()).then(pastMembers => this.setState({ pastMembers, loading: false }));
	}


}
